// @flow

import { Component } from 'react'
// $FlowFixMe
import { withRouter } from 'react-router-dom'

type Props = {
  location: Object,
  children: any
}

class ScrollToTop extends Component<Props> {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)



// WEBPACK FOOTER //
// ./src/components/ScrollToTop/index.js